import $api from "@/frontend/shared/api/axios";

export type TAccess = "Profile" | "Full" | null;

export async function patchRequestAccess({ id, access }: { id: number; access: TAccess }) {
  const response = await $api.patch(`/access-controls/${id}`, { access });
  return response.data;
}
